import { actions, types } from './requests'
export const GETCUSTOMERLIST_TYPES = {
    ...types('GETCUSTOMERLIST'),
}
export const GETCUSTOMERLIST_ACTIONS = {
    ...actions('GETCUSTOMERLIST'),
}